import React from "react";
import { Trash2, GripVertical, GitBranch } from "lucide-react";
import ActionTypeSelector from "./ActionTypeSelector";

export default function ConditionStep({ step, branchIndex, onUpdate, onDelete, onAddBranch, isOnlyBranch }) {
  const handleFieldChange = (updates) => {
    onUpdate({ ...step, ...updates });
  };

  return (
    <div className="bg-muted/50 rounded-lg border border-border p-4 space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <GripVertical className="w-4 h-4 text-gray-300 cursor-grab" />
          {branchIndex !== undefined && (
            <span className="text-xs font-medium text-violet-600 bg-violet-50 px-2 py-0.5 rounded">
              Branch {String.fromCharCode(65 + branchIndex)}
            </span>
          )}
        </div>
        <button
          type="button"
          onClick={onDelete}
          className="p-1 text-muted-foreground hover:text-red-500 transition-colors"
          title="Remove"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>

      {/* Condition — what the bot says that triggers this step */}
      <div>
        <label className="text-xs font-medium text-muted-foreground mb-1 block">
          When bot says
        </label>
        <textarea
          value={step.condition || ""}
          onChange={(e) => handleFieldChange({ condition: e.target.value })}
          className="form-textarea text-sm"
          rows={2}
          placeholder="e.g. Thank you for calling, how can I help you today?"
        />
        <p className="text-xs text-muted-foreground mt-0.5">
          What the agent says that triggers this response
        </p>
      </div>

      {/* Action — what the test caller does */}
      <ActionTypeSelector
        actionType={step.action_type}
        actionParams={step.action_params}
        action={step.action}
        fixedMessage={step.fixed_message}
        onChange={handleFieldChange}
      />

      {/* Add Branch button */}
      {isOnlyBranch && (
        <button
          type="button"
          onClick={onAddBranch}
          className="flex items-center gap-1.5 text-xs text-violet-600 hover:text-violet-700 font-medium mt-2"
        >
          <GitBranch className="w-3.5 h-3.5" />
          Add branch at this step
        </button>
      )}
    </div>
  );
}
